<template>
  <multiselect
      v-model="selectedItem"
      @update:modelValue="onSelectItem"
      :options="optionsList"
      :placeholder="$t('settings.generic.select-items')"
      label="translationKey" track-by="value"
      class="tracking-multiselect fit-content statuses-select"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :show-labels="false"
      :show-no-results="false"
      :show-no-options="false"
      :allow-empty="false"
  >
    <template #placeholder>
      <span>
        {{ $t('settings.generic.select-placeholder') }}
      </span>
    </template>
    <template #option="props">
      <div class="tracking-multiselect-with-checkbox">
        <span class="option__title">{{ $t(props.option.translationKey) }}</span>
      </div>
    </template>
    <template #singleLabel>
      <span class="option__title pr-5">
        <span class="option__title">{{ $t(selectedItem.translationKey) }}</span>
      </span>
    </template>
  </multiselect>
</template>

<script>

import Multiselect from "vue-multiselect";
import {GeoFenceColor} from "@/assets/js/enums/GeoFenceColor.ts";

export default {
  name: "ChooseGeoFenceColor",
  components: {Multiselect},
  props: {
    modelValue: {
      type: [String],
      default() { return null; }
    },
    addAllOption: {
      type: [Boolean],
      default: false
    }
  },
  data() {
    const geoFenceColors = GeoFenceColor.all();
    if (this.addAllOption) {
      geoFenceColors.unshift({value: null, translationKey: 'generic.all'});
    }

    return {
      selectedItem: this.modelValue,
      optionsList: geoFenceColors
    }
  },
  computed: {
    isAllSelected() {
      return !this.selectedStatus;
    },
    selectedStatus() {
      return this.selectedItem?.value;
    }
  },
  mounted() {
    if (this.selectedItem || this.addAllOption) {
      const selectedItem = this.optionsList.find(x => x.value === this.selectedItem);
      this.onSelectItem(selectedItem, false);
    }
  },
  watch: {
    modelValue(value) {
      this.selectedItem = this.optionsList.find(x => x.value === value);
    }
  },
  methods: {
    onSelectItem(data, triggerValueUpdate = true) {
      this.selectedItem = data;
      if (triggerValueUpdate) {
        this.$emit('update:modelValue', this.selectedItem?.value);
      }
    },
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables.scss';

.statuses-select {
  width: 173px;
}

// Mobile:
@media (max-width: $breaking-point) {
  .statuses-select {
    width: 100%;
  }
}
</style>